import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    CreatePlanInput,
    PlanFilterInput,
    PlanQuotaAttachmentInput,
    PlanTaskCategoryAttachmentInput,
    UpdatePlanInformationInput,
} from './inputs';
import { PlanRef } from './refs';
import { PlanResource } from './resources';

export default class Plan {
    private basePath = '/api/plan';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of plans
    get = async (filter?: PlanFilterInput): Promise<CollectionResource<PlanResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single plan
    getById = async (id: ID): Promise<PlanResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Create new plan
    create = async (input: CreatePlanInput): Promise<PlanRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Update plan information
    update = async (id: ID, input: UpdatePlanInformationInput): Promise<PlanRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archive plan
    archive = async (id: ID): Promise<PlanRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Restore archived plan
    restore = async (id: ID): Promise<PlanRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);

        return data;
    };

    // Publish plan
    publish = async (id: ID): Promise<PlanRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/publish`);

        return data;
    };

    // Set assigned task category groups
    setTaskCategoryGroups = async (id: ID, input: ID[]): Promise<PlanRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/task-category-group`, {
            task_category_group_ids: input,
        });

        return data;
    };

    // Sets task category attachment list
    setTaskCategoryAttachmentList = async (id: ID, input: PlanTaskCategoryAttachmentInput[]): Promise<PlanRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/task-category`, {
            task_categories: input,
        });

        return data;
    };

    // Sets quota attachment list
    setQuotaAttachmentList = async (id: ID, input: PlanQuotaAttachmentInput[]): Promise<PlanRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/quota`, {
            quotas: input,
        });

        return data;
    };
}
